import React from 'react';
import BenchHeatReport from './BenchHeatReport';
import '../styles/erprecruitment.css';

const BenchHeatReportPage = () => {
  return (
    <div className="bench-heat-report-page" style={{ padding: '0', minHeight: '100vh' }}>
      <BenchHeatReport />
    </div>
  );
};

export default BenchHeatReportPage;
